const SET_NOTIFICATION = (state, notification) => {
  notification = Object.assign({type:'success',content:null, callback:null},notification)
  state.notification = notification
}

const SET_CONFIG = (state, config) => {
  state.config = Object.assign(state.config,config)
}

const SET_VERSION = (state, version) => {
  state.version = version
}

const SET_RESPONSE = (state, response) => {
  state.response = response
}

const SET_LOCATION = (state, location) => {
  state.location = location
}

const SET_NAVIGATION = (state, navigation) => {
  state.navigation = navigation
}

const SET_DRAWER = (state, drawer) => {
  state.drawer = !state.drawer
}

const SET_DRAWER_HIDDEN = (state, drawer_hidden) => {
  state.drawer_hidden = (drawer_hidden === undefined ? false : drawer_hidden)
}

export {
  SET_NOTIFICATION,
  SET_CONFIG,
  SET_VERSION,
  SET_RESPONSE,
  SET_LOCATION,
  SET_NAVIGATION,
  SET_DRAWER,
  SET_DRAWER_HIDDEN
}



// WEBPACK FOOTER //
// ./src/store/common/mutations.js